"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var Theme = _interopRequireWildcard(require("../../../theme"));
var _Info = _interopRequireDefault(require("@mui/icons-material/Info"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Enrolment = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(Enrolment, _PureComponent);
  function Enrolment() {
    var _this;
    (0, _classCallCheck2["default"])(this, Enrolment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Enrolment, [].concat(args)), _this._saveEnrolmentAnswer = function (questionID, answer) {
      var memberData = _this.props.purchaseData.memberData;
      var enrolmentQuestions = _this.props.purchaseData.enrolmentQuestions;
      if (!enrolmentQuestions[questionID]) {
        enrolmentQuestions[questionID] = {
          questionID: questionID,
          answer: answer
        };
      } else {
        enrolmentQuestions[questionID].answer = answer;
      }
      if (_this.props.product.enrolmentQuestions[questionID].memberRecordField && _this.props.product.enrolmentQuestions[questionID].memberRecordField.length > 0) {
        memberData[_this.props.product.enrolmentQuestions[questionID].memberRecordField] = answer;
      }
      _this.props.savePurchaseData(_objectSpread(_objectSpread({}, _this.props.purchaseData), {}, {
        memberData: _objectSpread({}, memberData),
        enrolmentQuestions: enrolmentQuestions
      }));
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Enrolment, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var styles = {
        bulletBlock: {
          display: "flex",
          flexDirection: "row",
          flex: 1,
          marginBottom: 20,
          alignItems: 'flex-start'
        },
        questionBlock: {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginTop: 20
        }
      };
      var product = this.props.product;
      var purchaseData = this.props.purchaseData;
      var enrolmentErrors = this.props.enrolmentErrors;
      var productName = "".concat(product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.voluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.optional), " ").concat(product.name.primary[this.props.member.language]);
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: 20
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "inline"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.youHaveSelected), " "), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        display: "inline"
      }, productName), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "inline"
      }, " ".concat(_i18n["default"].t(_tokens["default"].labels.marketplace["with"])), " "), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        display: "inline"
      }, product.carrier[this.props.member.language], ". "), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        display: "inline"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.beforeYouGetStarted))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.bulletBlock
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        "aria-label": "info",
        style: {
          fontSize: 15,
          color: Theme.colors.mediumGrey,
          marginRight: 10
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.productSeparateInfoVoluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.productSeparateInfoOptional))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.bulletBlock
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        "aria-label": "info",
        style: {
          fontSize: 15,
          color: Theme.colors.mediumGrey,
          marginRight: 10
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.coverageEffectiveDate, {
        product: productName
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.bulletBlock
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        "aria-label": "info",
        style: {
          fontSize: 15,
          color: Theme.colors.mediumGrey,
          marginRight: 10
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.invoiceInfoVoluntary) : _i18n["default"].t(_tokens["default"].labels.marketplace.invoiceInfoOptional))), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.bulletBlock
      }, /*#__PURE__*/_react["default"].createElement(_Info["default"], {
        "aria-label": "info",
        style: {
          fontSize: 15,
          color: Theme.colors.mediumGrey,
          marginRight: 10
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, product.type.toUpperCase() === 'VOLUNTARY' ? _i18n["default"].t(_tokens["default"].labels.marketplace.productChangeInfoVoluntary, {
        product: productName
      }) : _i18n["default"].t(_tokens["default"].labels.marketplace.productChangeInfoOptional, {
        product: productName
      }))), Object.keys(product.enrolmentQuestions).length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, Object.keys(product.enrolmentQuestions).length > 0 && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        light: true,
        margin: "20px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.marketplace.disclosureInfo, {
        product: productName
      })), Object.keys(product.enrolmentQuestions).map(function (questionID) {
        var question = product.enrolmentQuestions[questionID];
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: styles.questionBlock,
          key: questionID
        }, enrolmentErrors[questionID] && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          small: true,
          bold: true,
          color: "red",
          margin: "10px 0 0 0"
        }, _i18n["default"].t(_tokens["default"].labels.marketplace.selectOptionInfo)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          small: true,
          bold: true,
          margin: "0 10px 0 0"
        }, question.verbiage[_this2.props.member.language]), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
          allowToggleOff: false,
          first: {
            title: _i18n["default"].t(_tokens["default"].buttons.yes),
            selected: purchaseData.enrolmentQuestions[questionID].answer === true,
            field: 'yes',
            customStyle: {
              fontSize: 12
            }
          },
          second: {
            title: 'No',
            selected: purchaseData.enrolmentQuestions[questionID].answer === false,
            field: 'no',
            customStyle: {
              fontSize: 12
            }
          },
          handleChange: function handleChange(field) {
            _this2._saveEnrolmentAnswer(question.questionID, field === 'yes');
          }
        }));
      }))));
    }
  }]);
  return Enrolment;
}(_react.PureComponent);
var _default = exports["default"] = Enrolment;